import * as React from 'react';
import { useState } from 'react';
import { Box, Button, TextField } from '@mui/material';
import { CreateButton, useListContext } from 'react-admin';

const OrderListFilterForm = () => {
    const {
        filterValues,
        setFilters,
    } = useListContext();

    // Local state for inputs
    const [localFilters, setLocalFilters] = useState({
        c: filterValues.c || '',
        p: filterValues.p || '',
        dl: filterValues.dl || '',
        r: filterValues.r || ''
    });

    // Update local state when filterValues change (e.g., when navigating back)
    React.useEffect(() => {
        console.log('[OrderListFilterForm] filterValues changed:', filterValues);
        setLocalFilters({
            c: filterValues.c || '',
            p: filterValues.p || '',
            dl: filterValues.dl || '',
            r: filterValues.r || ''
        });
    }, [filterValues]);

    const handleInputChange = (field) => (event) => {
        setLocalFilters(prev => ({
            ...prev,
            [field]: event.target.value
        }));
    };

    const onSubmit = (e) => {
        e.preventDefault();
        console.log('[OrderListFilterForm] Submit clicked with values:', localFilters);
        const filtersToApply = {};
        Object.keys(localFilters).forEach(key => {
            if (localFilters[key]) {
                filtersToApply[key] = localFilters[key];
            }
        });
        if (Object.keys(filtersToApply).length > 0) {
            setFilters(filtersToApply);
        }
    };

    const resetFilter = () => {
        console.log('[OrderListFilterForm] Clear button clicked');
        console.log('[OrderListFilterForm] Current filterValues:', filterValues);
        setLocalFilters({ c: '', p: '', dl: '', r: '' });
        setFilters({}, []);
    };

    return (
        <form onSubmit={onSubmit}>
                <Box display="flex" justifyContent="space-between" width="100%">
                    <Box display="flex" alignItems="flex-start" mb={0} mt={0}>
                        <Box component="span" ml={0} mr={2} mb={0} mt={0}>
                            <TextField
                                size="small"
                                variant="filled"
                                label="Customer"
                                value={localFilters.c}
                                onChange={handleInputChange('c')}
                            />
                        </Box>
                        <Box component="span" mr={2} mb={0} mt={0}>
                            <TextField
                                size="small"
                                variant="filled"
                                label="Product"
                                value={localFilters.p}
                                onChange={handleInputChange('p')}
                            />
                        </Box>
                        <Box component="span" mr={2} mb={0} mt={0}>
                            <TextField
                                size="small"
                                variant="filled"
                                label="Delivery Location"
                                value={localFilters.dl}
                                onChange={handleInputChange('dl')}
                            />
                        </Box>
                        <Box component="span" mr={2} mb={0} mt={0}>
                            <TextField
                                size="small"
                                variant="filled"
                                label="Release #"
                                value={localFilters.r}
                                onChange={handleInputChange('r')}
                            />
                        </Box>
                    </Box>
                    <Box display="flex" alignItems="center" mb={0} mt={0}>
                        <Box component="span" mr={2} mb={0}>
                            <Button variant="outlined" color="primary" type="submit">
                            Filter
                            </Button>
                        </Box>
                        <Box component="span" mr={2} mb={0}>
                            <Button variant="outlined" onClick={resetFilter}>
                            Clear
                            </Button>
                        </Box>
                        <Box component="span" mr={2} mb={0}>
                            <CreateButton basePath="/orders" label="Create" />
                        </Box>
                    </Box>
                </Box>
            </form>
    );
};

export default OrderListFilterForm;
